<template>
  <div class="Dropdown">
    <div class="Dropdown__selected" :class="{ isOpen }" @mousedown="toggle()">
      <slot name="selected" />
    </div>

    <SlideDownTransition>
      <div v-if="isOpen" class="Dropdown__menu" :class="{ isOpen, isOnRight: right }" @click="close()">
        <slot :close="close" name="options" />
      </div>
    </SlideDownTransition>
  </div>
</template>

<script>
import SlideDownTransition from '~/components/transitions/SlideDownTransition.vue'

export default {
  components: {
    SlideDownTransition
  },

  props: {
    right: Boolean
  },

  data() {
    return {
      isOpen: false
    }
  },

  mounted() {
    window.addEventListener('mousedown', this.closeByMousedown, true)
    window.addEventListener('keydown', this.closeByEsc, true)
  },

  destroyed() {
    window.removeEventListener('mousedown', this.closeByMousedown, true)
    window.removeEventListener('keydown', this.closeByEsc, true)
  },

  methods: {
    toggle() {
      this.isOpen = !this.isOpen
    },

    close() {
      this.isOpen = false
    },

    closeByMousedown(e) {
      if (!this.$el.contains(e.target)) {
        this.close()
      }
    },

    closeByEsc(e) {
      if (e.code === 'Escape') {
        this.close()
      }
    }
  }
}
</script>

<style>
.Dropdown {
  @apply relative;
}

.Dropdown__selected {
  @apply relative flex items-center whitespace-nowrap bg-white border rounded cursor-pointer select-none;

  &:hover {
    @apply text-black border-gray-400;
  }

  &.isOpen {
    @apply border-gray-600 outline-none shadow-none;
  }
}

.Dropdown__item {
  @apply block px-4 py-2 whitespace-nowrap font-normal rounded;

  &:hover {
    @apply text-black no-underline bg-gray-200;
  }

  & + & {
    /* @apply border-t; */
  }

  &--disabled {
    @apply text-gray-400 font-normal pointer-events-none;
  }
}

.Dropdown__menu {
  @apply absolute z-10 left-0 top-full hidden my-2 p-2 min-w-full bg-white border rounded-lg shadow-lg;

  &.isOpen {
    @apply block;
  }

  &.isOnRight {
    @apply left-auto right-0;
  }
}
</style>
